import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { merge } from 'rxjs';
import { INebengebaeude } from '../../models/nebengebaeude';
import { PopupService } from '../../service/popup.service';
import {DataService} from '../../service/data.service';

@Component({
  selector: 'app-nebengebaeude',
  templateUrl: './nebengebaeude.component.html',
  styleUrls: ['./nebengebaeude.component.scss']
})
export class NebengebaeudeComponent implements OnInit, OnChanges, OnDestroy {

  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  formGroup: UntypedFormGroup;

  @Input()
  showLeitungswasser: boolean;

  @Input()
  showTopEigenheim: boolean;

  @Input()
  index: number;

  @Output()
  calculateRatePendingEvent = new EventEmitter<void>();

  constructor(public translateService: TranslateService, public popupService: PopupService, public dataService: DataService) { }

  static createFormGroup(fb: UntypedFormBuilder) {
    return fb.group({
      gebaeudeArt: new UntypedFormControl('', Validators.required),
      flaecheQm: new UntypedFormControl('', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.min(1), Validators.max(200)]),
      bauweise: new UntypedFormControl('', Validators.required),
      variante: new UntypedFormControl('', Validators.required),
    });
  }

  ngOnInit(): void {
    this.onValueChanged();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.showLeitungswasser && changes.showLeitungswasser.currentValue !== changes.showLeitungswasser.previousValue ||
      changes.showTopEigenheim && changes.showTopEigenheim.currentValue !== changes.showTopEigenheim.previousValue) {
      Promise.resolve().then(() => this.variantenChanged());
    }
  }

  ngOnDestroy() {
    this.calculateRatePendingEvent.emit();
  }

  get gebaeudeArt() { return this.formGroup.get('gebaeudeArt'); }
  get flaecheQm() { return this.formGroup.get('flaecheQm'); }
  get bauweise() { return this.formGroup.get('bauweise'); }
  get variante() { return this.formGroup.get('variante'); }

  get showSonstigeGebaeudeArt() {
    return this.gebaeudeArt.value === 5 ? true : false;
  }

  getGebaeudeArten(){
    return this.dataService.hvNebenGebaeudeArten;
  }

  getVarianten() {
    return new Map(Array.from(
      this.dataService.hvVarianten).filter(([key]) => (this.showLeitungswasser || key !== 1 && key !== 2) && (this.showTopEigenheim || key !== 1 && key !== 3)));
  }

  variantenChanged(): void {
    if (this.variante.value && !new Map(Array.from(this.getVarianten())).has(Number(this.variante.value))) {
      this.variante.setValue(null);
    }
  }

  onValueChanged(): void {
    merge(
      this.gebaeudeArt.valueChanges,
      this.flaecheQm.valueChanges,
      this.bauweise.valueChanges,
      this.variante.valueChanges
    ).subscribe(() => {
      this.calculateRatePendingEvent.emit();
    });
  }

  getNebengebaeude(hoechsthaftungssumme: number): INebengebaeude {
    return {
      GebaeudeArt: this.gebaeudeArt.value,
      FlaecheQm: this.flaecheQm.value,
      BauweiseId: Number(this.bauweise.value),
      Variante: this.variante.value,
      Hoechsthaftungssumme: hoechsthaftungssumme
    };
  }

  setNebengebaeude(nb: INebengebaeude): void {
    this.gebaeudeArt.setValue(nb.GebaeudeArt);
    this.flaecheQm.setValue(nb.FlaecheQm);
    this.bauweise.setValue(nb.BauweiseId.toString());
    this.variante.setValue(nb.Variante);
  }
}
